"use strict";

exports.__esModule = true;
exports.Timer = void 0;
var _react = require("react");
var _Utils = require("../../../Utils");
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var Timer = exports.Timer = /*#__PURE__*/function (_Component) {
  function Timer() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.hasMounted = false;
    _this.unsubscribe = null;
    _this.state = {
      now: Date.now()
    };
    _this.restartTimer = function () {
      if (_this.unsubscribe !== null) {
        _this.unsubscribe();
      }
      _this.unsubscribe = (0, _Utils.createTimer)(_this.tick, _this.props.interval);
    };
    _this.tick = function () {
      if (!_this.hasMounted) {
        return;
      }
      var now = Date.now();
      _this.setState({
        now: now
      });
    };
    return _this;
  }
  _inheritsLoose(Timer, _Component);
  var _proto = Timer.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.unsubscribe = (0, _Utils.createTimer)(this.tick, this.props.interval);
    this.hasMounted = true;
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribe !== null) {
      this.unsubscribe();
      this.unsubscribe = null;
    }
    this.hasMounted = false;
  };
  _proto.render = function render() {
    return this.props.children({
      now: this.state.now,
      restartTimer: this.restartTimer
    });
  };
  return Timer;
}(_react.Component);